<template>
  <div>
    <b-form>
      <div class="form-group flex-inline-form-md">
        <b-input-group class="fill-width">
          <b-input-group-text slot="prepend">
            <i class="fa fa-search"></i>
          </b-input-group-text>
          <b-form-input
            type="text"
            :placeholder="`Search ${label} by name, partner name or partner id`"
            @input="onChangeSearchQuery($event)"
            v-model="searchQuery"></b-form-input>
        </b-input-group>
        <b-input-group style="min-width: 200px;">
          <b-form-select
            v-model="sortType"
            @change="onChangeSortType($event)"
            :options="sortOptions"></b-form-select>
        </b-input-group>
        <b-input-group>
          <b-button @click="createCompany()" variant="success" class="w-100">New {{ label }} &nbsp;<i class="fa fa-plus"></i></b-button>
        </b-input-group>
      </div>
    </b-form>
    <div class="list-group mb-2" v-if="totalRows && !withType">
      <b-nav>
        <b-nav-item
          v-show="count_active"
          @click="navSelected('ACTIVE')"
          :active="filterType === 'ACTIVE'">Active ({{count_active}})</b-nav-item>
        <b-nav-item
          v-show="count_default"
          @click="navSelected('DEFAULT')"
          :active="filterType === 'DEFAULT'">Default ({{count_default}})</b-nav-item>
        <b-nav-item
          v-show="count_transporter"
          @click="navSelected('TRANSPORTER')"
          :active="filterType === 'TRANSPORTER'">Transporter ({{count_transporter}})</b-nav-item>
        <b-nav-item
          v-show="count_customer"
          @click="navSelected('CUSTOMER')"
          :active="filterType === 'CUSTOMER'">Customer ({{count_customer}})</b-nav-item>
        <b-nav-item
          v-show="count_manufacturer"
          @click="navSelected('MANUFACTURER')"
          :active="filterType === 'MANUFACTURER'">Client ({{count_manufacturer}})</b-nav-item>
        <b-nav-item
          v-show="count_inactive"
          @click="navSelected('INACTIVE')"
          :active="filterType === 'INACTIVE'">Blocked ({{count_inactive}})</b-nav-item>
      </b-nav>
    </div>
    <b-overlay :show="isCompanyListLoading">
      <b-list-group class="no-box" v-if="totalRows">
        <b-list-group-item
          v-for="company in companies"
          :key="company.id"
          >
          <div class="pull-left">
            <router-link :to="detailUrl + company.id"><strong>{{company.name}}</strong>
              <b-badge pill variant="danger" v-if="!company.active">Blocked</b-badge>
            </router-link>
            <p class="mb-1 small text-muted" v-if="getPartnerName(company)">
              <ul class="mb-1 partner--list">
                <li
                  v-for="partner in getPartnerName(company)"
                  :key="partner.key">
                    <i class="fa fa-check-square"></i>
                      {{partner.id}} - {{partner.name}}
                </li>
              </ul>
            </p>
            <p class="mb-1">{{company.type === 'MANUFACTURER' ? 'CLIENT' : company.type}}</p>
            <small :title="formatDateTime(company.created_at)">Created at: {{formatDateDistance(company.created_at)}}</small>
          </div>
          <div v-if="hasAccessCompany(company)" class="pull-right">
            <b-button
              v-if="canIEditCompany(company)"
              @click="editCompany(company.id)"
              variant="outline-primary"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
            <b-dropdown v-if="canIDeleteCompany(company)"
              variant="outline-primary" class="m-md-2">
              <i class="fa fa-gear" slot="button-content"></i>
              <b-dropdown-item
                class="text-warning">Disable
              </b-dropdown-item>
              <b-dropdown-item
                @click="deleteCompany(company.id)"
                class="text-danger">Remove</b-dropdown-item>
            </b-dropdown>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div style="height:150px;" v-if="isCompanyListLoading && totalRows === 0"></div>
    </b-overlay>
    <b-pagination class="mt-3" align="center" size="md" :total-rows="totalRows" v-model="currentPage" :per-page="query_count" v-if="totalRows">
    </b-pagination>
    <b-alert show v-if="isFetched & totalRows === 0">No companies match with the search term. Please try another keywords.</b-alert>
    <div>
      <b-modal
        id="delete_company"
        title="Delete Company"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="confirmedDeleteCompany(deleteCompanyId)">
        <p class="my-4">Are you sure do you want to delete this {{ label }}?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>

import dateMixin from '@/mixins/date';
import companyMixin from '@/mixins/company';
import { throttle, isEmpty, omit, uniqBy, get } from 'lodash';

export default {
  name: 'company_table',
  mixins: [dateMixin, companyMixin],
  props: {
    parentId: {
      type: Number,
      required: false,
      default: null,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: 'company',
    },
    detailUrl: {
      type: String,
      required: false,
      default: '/admin/companies/',
    },
  },
  data() {
    return {
      deleteCompanyId: null,
      searchQuery: '',
      filterType: 'ACTIVE',
      currentPage: 1,
      sortOptions: [
        { value: null, text: '== Sort by ==', disabled: true },
        { value: 'NAME.ASC', text: 'Name A-Z' },
        { value: 'NAME.DESC', text: 'Name Z-A' },
        { value: 'CREATED_AT.DESC', text: 'Last Created' },
        { value: 'CREATED_AT.ASC', text: 'Oldest Created' },
      ],
      sortType: null,
    };
  },
  created() {
    this.$store.commit('companies/CLEAR_QUERY');
    this.$store.commit('companies/SET_QUERY_TYPE', this.type);
    this.$store.commit('companies/SET_QUERY_ACTIVE', 'true');
    if (typeof this.parentId === 'number' && this.parentId !== 0) {
      this.$store.commit('companies/SET_QUERY_PARENT_ID', this.parentId);
    }
    this.initFromUrl();
  },
  computed: {
    companies() {
      const companies = this.$store.getters['companies/companies'];
      return uniqBy(companies, 'id');
    },
    count_all() {
      return this.$store.getters['companies/count_all'];
    },
    count_default() {
      return this.$store.getters['companies/count_default'];
    },
    count_transporter() {
      return this.$store.getters['companies/count_transporter'];
    },
    count_customer() {
      return this.$store.getters['companies/count_customer'];
    },
    count_active() {
      return this.$store.getters['companies/count_active'];
    },
    count_inactive() {
      return this.$store.getters['companies/count_inactive'];
    },
    count_manufacturer() {
      return this.$store.getters['companies/count_manufacturer'];
    },
    query_count() {
      return this.$store.getters['companies/query_count'];
    },
    totalRows() {
      if (this.filterType === 'DEFAULT') {
        return this.count_default;
      } else if (this.filterType === 'TRANSPORTER') {
        return this.count_transporter;
      } else if (this.filterType === 'CUSTOMER') {
        return this.count_customer;
      } else if (this.filterType === 'ACTIVE') {
        return this.count_active;
      } else if (this.filterType === 'INACTIVE') {
        return this.count_inactive;
      }
      return this.count_all;
    },
    withType() {
      return typeof this.type === 'string';
    },
    is_data_loaded() {
      return this.$store.getters['companies/dataLoaded'];
    },
    stateCompanies() {
      return this.$store.getters['companies/dataStateCompanies'];
    },
    isCompanyListLoading() {
      return this.stateCompanies === 'LOADING';
    },
    isFetched() {
      return this.stateCompanies === 'LOADED';
    },
  },
  watch: {
    currentPage(newValue) {
      if (this.is_data_loaded) {
        this.$store.commit('companies/SET_QUERY_PAGE', newValue);
        this.loadData();
      }
    },
  },
  methods: {
    getPartnerName(company) {
      const sapData = get(company, 'metadata.sapData') || {};
      const id = get(company, 'metadata.partnerId');
      const names = ['NAME1', 'NAME2', 'NAME3'];
      const partners = [];
      const pushedNames = [];

      names.forEach((key) => {
        const name = get(sapData, key);
        if (!isEmpty(name) && !pushedNames.includes(name)) {
          partners.push({ name, key, id });
          pushedNames.push(name);
        }
      });

      if (isEmpty(partners)) {
        return false;
      }
      return partners;
    },
    initFromUrl() {
      const { query } = this.$route;

      if (query.sort !== undefined) {
        this.onChangeSortType(query.sort, true);
      }
      if (query.q !== undefined) {
        this.onChangeSearchQuery(query.q, true);
      }

      this.loadInfoAndData();
    },
    navSelected(type) {
      this.filterType = type;
      let queryType = type;
      let active = 'all';

      if (type === 'ACTIVE') {
        queryType = null;
        active = 'true';
      } else if (type === 'INACTIVE') {
        queryType = null;
        active = 'false';
      }

      this.currentPage = 1;
      this.$store.commit('companies/SET_QUERY_PAGE', 1);
      this.$store.commit('companies/SET_QUERY_TYPE', queryType);
      this.$store.commit('companies/SET_QUERY_ACTIVE', active);
      this.loadData();
    },
    updateSearchQuery: throttle((context, searchTerm) => {
      const searchQuery = searchTerm.trim();
      context.$store.commit('companies/SET_QUERY_SEARCH', searchQuery);
      context.loadInfoAndData();
    }, 500, {
      leading: false,
    }),
    onChangeSortType(newValue, fromInit = false) {
      this.$router.push({ query: { ...this.$route.query, sort: newValue } });
      this.$store.commit('companies/SET_QUERY_SORT', newValue);
      this.sortType = newValue;

      if (!fromInit) {
        this.loadData();
      }
    },
    onChangeSearchQuery(newValue, fromInit = false) {
      this.$store.commit('companies/SET_QUERY_SEARCH', newValue);
      if (!isEmpty(newValue)) {
        this.$router.push({ query: { ...this.$route.query, q: newValue } });
      } else {
        this.$router.push({ query: { ...omit(this.$route.query, ['q']) } });
      }
      this.searchQuery = newValue;

      if (!fromInit) {
        this.updateSearchQuery(this, newValue);
      }
    },
    loadInfoAndData() {
      this.$store.dispatch('companies/LOAD_INFO');
      this.loadData();
    },
    loadData() {
      return this.$store.dispatch('companies/LOAD_DATA');
    },
    editCompany(companyId) {
      this.$router.push(`/admin/companies/${companyId}/edit`);
    },
    createCompany() {
      this.$router.push('/admin/companies/create');
    },
    deleteCompany(companyId) {
      this.deleteCompanyId = companyId;
      this.$bvModal.show('delete_company');
    },
    confirmedDeleteCompany(companyId) {
      this.$store.dispatch('companies/DELETE_DATA', companyId).then((ok) => {
        if (ok) this.loadInfoAndData();
      });
    },
    /* deleteCompany(companyId) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        // showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('companies/DELETE_DATA', companyId).then((ok) => {
            if (ok) this.loadInfoAndData();
          });
          this.$swal('Deleted', 'You successfully deleted this file', 'success');
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info');
        }
      });
    }, */
  },
};
</script>

<style lang="sass" scoped>
.fa-modify
  color: #000000;
  margin-left: 45%;

.partner--list
  list-style: none;
  margin: 0px;
  padding: 0px;
  padding-left: 5px;
</style>



// WEBPACK FOOTER //
// src/components/CompanyTable.vue